import { INTERNAL_PATHS } from "routes/paths";
import { handleDecagonChat } from "services/decagon";

export const TRANSPARENT_NAVBAR_PAGES = [
  INTERNAL_PATHS.SELL_GIFT_CARDS,
  INTERNAL_PATHS.PARTNER_PROGRAM,
  INTERNAL_PATHS.SHOP
];

const {
  BUY_GIFT_CARDS,
  SELL_GIFT_CARDS,
  USER_LOG_IN,
  USER_SIGN_UP,
  GET_THE_APP,
  MY_ACCOUNT,
  MY_LISTINGS,
  MY_ORDERS,
  MY_SCHEDULED_GIFTS,
  MY_RAISE_CASH,
  MY_REFERRALS,
  BRAND_ALERTS,
  SETTINGS
} = INTERNAL_PATHS;

export const LEFT_SIDE_ITEMS = [
  {
    path: BUY_GIFT_CARDS,
    label: "Buy",
    logId: "buy-gift-cards-link"
  },
  {
    path: SELL_GIFT_CARDS,
    label: "Sell",
    logId: "sell-gift-cards-link"
  }
];

export const RIGHT_SIDE_ITEMS = [
  {
    label: "Chat",
    logId: "chat-link",
    onClick: handleDecagonChat,
    showLogged: true
  },
  {
    path: USER_LOG_IN,
    label: "Log In",
    logId: "log-in-link"
  },
  {
    path: USER_SIGN_UP,
    label: "Sign Up",
    logId: "sign-up-link"
  }
];

export const MENU_ITEMS = [
  {
    path: BUY_GIFT_CARDS,
    label: "Buy Gift Cards",
    logId: "buy-gift-cards-link",
    mobileOnly: true
  },
  {
    path: SELL_GIFT_CARDS,
    label: "Sell Gift Cards",
    logId: "sell-gift-cards-link",
    mobileOnly: true
  },
  {
    path: GET_THE_APP,
    label: "Get The App",
    logId: "get-the-app-link",
    mobileOnly: true
  },
  {
    label: "divider",
    logId: "divider-1",
    divider: true
  },
  {
    path: MY_ACCOUNT,
    label: "Overview",
    logId: "overview-link",
    loggedIn: true,
    border: true
  },
  {
    path: MY_LISTINGS,
    label: "My Listings",
    logId: "my-listings-link",
    loggedIn: true
  },
  {
    path: MY_ORDERS,
    label: "My Orders",
    logId: "my-orders-link",
    loggedIn: true
  },
  {
    path: MY_SCHEDULED_GIFTS,
    label: "My Scheduled Gifts",
    logId: "my-scheduled-gifts",
    loggedIn: true
  },
  {
    path: MY_RAISE_CASH,
    label: "My GCX Cash",
    logId: "my-gcx-cash-link",
    loggedIn: true
  },
  {
    path: MY_REFERRALS,
    label: "Refer a Friend",
    logId: "refer-a-friend",
    loggedIn: true
  },
  {
    path: BRAND_ALERTS,
    label: "Brand Alerts",
    logId: "brand-alerts-link",
    loggedIn: true
  },
  {
    path: SETTINGS,
    label: "Settings",
    logId: "settings-link",
    border: true,
    loggedIn: true
  },
  {
    label: "divider",
    logId: "divider-2",
    divider: true
  },
  {
    label: "Chat",
    logId: "chat-link",
    onClick: handleDecagonChat,
    mobileOnly: true
  },
  {
    path: USER_SIGN_UP,
    label: "Sign Up",
    logId: "sign-up-link",
    loggedOut: true,
    mobileOnly: true
  },
  {
    path: USER_LOG_IN,
    label: "Log In",
    logId: "log-in-link",
    loggedOut: true,
    mobileOnly: true
  },
  {
    label: "Log Out",
    logId: "log-out-link",
    onClick: () => window.open(INTERNAL_PATHS.USER_LOGOUT, "_self"),
    loggedIn: true
  }
];
